import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Grid from '@material-ui/core/Grid';
import PackingItem from './PackingItem';
import PackingItemSkeleton from './PackingItem/PackingItemSkeleton';
import DataList from '@afosto/app-components-react/DataList';
import translations from './translations';

const DataListContainerGrid = props => <Grid container spacing={1} {...props} />;

const PackingList = ({ bulkActions, dataSource, onClick }) => {
  const intl = useIntl();
  const { selection: selectionModule = {} } = dataSource;

  const handleClick = item => event => {
    if (onClick && typeof onClick === 'function') {
      onClick(event, item);
    }
  };

  const renderItem = (item, props) => (
    <PackingItem
      {...props}
      key={item.id}
      disabled={selectionModule?.selectedItems?.length > 0}
      item={item}
      onClick={handleClick(item)}
    />
  );

  const renderSkeletonItem = key => <PackingItemSkeleton key={key} />;

  return (
    <DataList
      bulkActions={bulkActions}
      component={DataListContainerGrid}
      dataSource={dataSource}
      emptyMessage={intl.formatMessage(translations.emptyMessage)}
      renderItem={renderItem}
      renderSkeletonItem={renderSkeletonItem}
    />
  );
};

PackingList.propTypes = {
  bulkActions: PropTypes.array,
  dataSource: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

PackingList.defaultProps = {
  bulkActions: [],
  onClick: undefined,
};

export default PackingList;
